import styled from 'styled-components'

const BackgroundPositionWrapperUi = styled.div`
  display: flex;
  align-items: flex-end;
  min-height: 97px;
`

export default BackgroundPositionWrapperUi
